import { createContext } from 'react'

// react-select ignores a disabled <fieldset>, so every field reads the form's read-only state itself
export const FormReadOnlyContext = createContext(false)
